import { MKBBox } from '@bluebeam/markupkit-web';
import { SystemFuncArgs } from '$legacyecstatic';
import Canvas from 'editor/components/Canvas';
import Markup from 'editor/components/Markup';
import RFIPost from 'editor/components/RFIPost';
import Point from 'editor/geometry/Point';
import { Components } from '../components';

function drawControlPoint(
  x: number,
  y: number,
  ctx: CanvasRenderingContext2D
): void {
  ctx.fillStyle = '#f4f7fc';
  ctx.strokeStyle = '#4b585d';
  ctx.lineWidth = 1;
  ctx.moveTo(x, y);
  ctx.beginPath();
  ctx.arc(x, y, 3, 0, Math.PI * 2);
  ctx.fill();
  ctx.stroke();
}

function drawSquareControlPoints(
  bbox: MKBBox,
  padding: number,
  ctx: CanvasRenderingContext2D
) {
  // top left
  drawControlPoint(bbox.left - padding, bbox.top + padding, ctx);

  // top center
  drawControlPoint((bbox.left + bbox.right) / 2, bbox.top + padding, ctx);

  // top right
  drawControlPoint(bbox.right + padding, bbox.top + padding, ctx);

  // center right
  drawControlPoint(bbox.right + padding, (bbox.top + bbox.bottom) / 2, ctx);

  // bottom right
  drawControlPoint(bbox.right + padding, bbox.bottom - padding, ctx);

  // bottom center
  drawControlPoint((bbox.right + bbox.left) / 2, bbox.bottom - padding, ctx);

  // bottom left
  drawControlPoint(bbox.left - padding, bbox.bottom - padding, ctx);

  // left center
  drawControlPoint(bbox.left - padding, (bbox.top + bbox.bottom) / 2, ctx);
}

function drawLineControlPoints(points: Point[], ctx: CanvasRenderingContext2D) {
  for (const point of points) {
    drawControlPoint(point.x, point.y, ctx);
  }
}

export const renderControlPoints2Components = [Markup, Canvas];

export function renderControlPoints2(args: SystemFuncArgs<Components>): void {
  const { world, components } = args;
  const markupComp = components.get(Markup);
  const canvasComp = components.get(Canvas);

  const ctx = canvasComp.canvas.getContext('2d');
  if (!ctx) return;

  if (
    markupComp.selected &&
    !markupComp.isPunch &&
    markupComp.mkMarkup &&
    !markupComp.hidden
  ) {
    const bbox = markupComp.mkMarkup.getBBox();

    const padding = 5;

    ctx.save();

    const markupType = markupComp.mkMarkup.getType();

    switch (markupType) {
      case 'Square':
        drawSquareControlPoints(bbox, padding, ctx);
        break;
      case 'Line': // Both line and arrow right now.
        {
          const points = markupComp.mkMarkup.getPoints() as Point[];

          drawLineControlPoints(points, ctx);
        }
        break;
      case 'FreeText':
        // eslint-disable-next-line no-lone-blocks
        {
          const rfiPostEntity = world.locate(RFIPost);

          if (!markupComp.isRFI || rfiPostEntity) {
            drawSquareControlPoints(bbox, padding, ctx);
          }
        }
        break;
      default:
    }

    ctx.restore();
  }
}
